query GetDafAdvisorExternalOpexDonations(
  $dateFrom: ISO8601Date!
  $dateTo: ISO8601Date!
) {
  dafAdvisorExternalOpexDonations(dateFrom: $dateFrom, dateTo: $dateTo) {
    contact {
      id
      name
    }
    funds {
      id
      name
      legalEntity {
        name
      }
      adminFeeExemption
      dafPlan
    }
    numberOfDafs
    opexDonationsByMonth {
      month
      total {
        minorUnit
        currency
      }
    }
    caseRecords {
      id
      caseNumber
      description
      salesforceId
      transactionDate
      senderAmount {
        minorUnit
        currency
      }
      recipientAmountForRollUps {
        minorUnit
        currency
      }
    }
  }
}
